import '@leuven2030/framework/styles/base.css';
import PageApp from '@leuven2030/framework/Page/PageApp';

export default PageApp;
